import styled from 'styled-components'

export const CircularContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
`

export const CircularDescription = styled.div`
	text-align: center;
`
